import http from 'axios'
import urls from './manageClient.urls'

export default {
  getClientDetails: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.clients)
      .then(response => {
        commit('setClientDetails', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  updateClientDetails: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .put(urls.updateClient(data.clientName), data)
      .then(response => {
        dispatch('getClientDetails')
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  addClientDetails: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post(urls.addClient(data.clientName), data)
      .then(response => {
        dispatch('getClientDetails')
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },

  getClientDatabaseDetails: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.databases)
      .then(response => {
        commit('setClientDatabaseDetails', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  updateClientDatabaseDetails: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .put(urls.updateDatabase(data.databaseId), data)
      .then(response => {
        dispatch('getClientDatabaseDetails')
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  addClientDatabaseDetails: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post(urls.addDatabase, data)
      .then(response => {
        dispatch('getClientDatabaseDetails')
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  }
}
